import { render } from "./CarouselSlide.vue?vue&type=template&id=3e27807a&scoped=true"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"

import "./CarouselSlide.vue?vue&type=style&index=0&id=3e27807a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e27807a"]])

export default __exports__